import type { FormResponseValue, FormResponseValueAnswer } from "@tellescope/types-models";

export const deriveComputedValueKey = (
  intakeField: string | undefined | null,
  answer: FormResponseValueAnswer | undefined
): FormResponseValue["computedValueKey"] => {
  if (!intakeField || !answer) return undefined;
  if (intakeField === "height" && answer.value !== undefined && answer.value !== null) return "Height";
  if (intakeField === "weight" && typeof answer.value === "number") return "Weight";
  if (intakeField === "dateOfBirth" && answer.type === "dateString") return "Date of Birth";
  if (intakeField === "gender" && (answer.type === "multiple_choice" || answer.type === "Dropdown")) return "Gender";
  if (intakeField === "Address" && answer.type === "Address") return "State";
  return undefined;
};
